import { Injectable } from '@angular/core';
import { RoleGuard } from './role.abstract.guard';

@Injectable({ providedIn: 'root' })
export class DirectionGuard extends RoleGuard {
  role: string[] = ['direction'];
}
